import { AxiosError } from 'axios';
import { RequestProcessRequest } from 'web-library/models/Request';
import { POST_PROCESS_REQUEST_URL } from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostProcessRequest = ({ onSuccess, onError }: Input = {}) => {
  const postProcessRequest = async (requestData: RequestProcessRequest) => {
    const res = await axiosClient.post(POST_PROCESS_REQUEST_URL(requestData.requestUuid), {
      status: requestData.status,
      remarks: requestData.remarks,
    });
    return res.data;
  };

  return useCustomMutation(postProcessRequest, {
    onSuccess,
    onError,
  });
};
